module.exports = "<div class=rbn-pages-image><%if(thumbnailUrl){%><img src=\"<%=thumbnailUrl%>\"/><%}%></div> <div class=rbn-pages-label><span><%=pagesLabel%></span></div>";


//////////////////
// WEBPACK FOOTER
// ./src/templates/thumbnails-cell-template.html
// module id = 70
// module chunks = 0